import { render, staticRenderFns } from "./PlanBox.vue?vue&type=template&id=bbc06ee4&"
import script from "./PlanBox.vue?vue&type=script&lang=js&"
export * from "./PlanBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports